import {
  ADMISSION_TYPE_BOTTLE_SERVICE,
  ADMISSION_TYPE_GUEST_LIST,
  ADMISSION_TYPE_INVITATION,
  ADMISSION_TYPE_TICKET,
} from '@domain/admission';

export const getDefaultOfferNameTranslation = (type: string) => {
  if (type === ADMISSION_TYPE_TICKET) return 'offers:admissionTicketTitle';
  if (type === ADMISSION_TYPE_BOTTLE_SERVICE || type === ADMISSION_TYPE_BOTTLE_SERVICE.toLowerCase())
    return 'offers:admissionBottleServiceTitle';
  if (type === ADMISSION_TYPE_GUEST_LIST || type === ADMISSION_TYPE_GUEST_LIST.toLocaleLowerCase())
    return 'offers:admissionGuestListTitle';
  if (type === ADMISSION_TYPE_INVITATION) return 'invitations:defaultTitle';

  return '';
};
